export const setupDotBtns = (dotsArray, embla) => {
	dotsArray.forEach((dotNode, i) => {
		const slide = embla.slideNodes()[i];
		const dotControls = slide.getAttribute('id');
		const dotContent = slide.getAttribute('data-name');
		if (dotContent) {
			dotNode.innerHTML = dotContent;
		}
		if (dotControls) {
			dotNode.setAttribute('aria-controls', dotControls);
		}

		dotNode.setAttribute('role', 'tab');
		dotNode.addEventListener('click', () => embla.scrollTo(i), false);
	});
};

export const generateDotBtns = (dots, embla) => {
	if (!dots || !embla) return [];

	const hasSingleSlide = (embla.slideNodes?.()?.length ?? 0) <= 1;
	if (hasSingleSlide) {
		dots.innerHTML = '';
		dots.setAttribute('hidden', '');
		dots.classList.add('is-disabled');
		return [];
	}

	dots.removeAttribute('hidden');
	const template =
		document.documentElement.lang === 'cs'
			? '<button class="embla__dot" type="button" tabindex="-1">Posunout na slide %i</button>'
			: '<button class="embla__dot" type="button" tabindex="-1">Move to slide %i</button>';
	dots.innerHTML = embla
		.scrollSnapList()
		.reduce((acc, _, i) => acc + template.replace('%i', i + 1), '');
	const dotsAll = dots.querySelectorAll('.embla__dot');
	if (dotsAll.length == 1) {
		dots.classList.add('is-disabled');
	} else {
		dots.classList.remove('is-disabled');
	}
	return [].slice.call(dots.querySelectorAll('.embla__dot'));
};

export const selectDotBtn = (dotsArray, embla) => () => {
	const previous = embla.previousScrollSnap();
	const selected = embla.selectedScrollSnap();

	if (!dotsArray?.length) return;
	dotsArray[previous]?.classList.remove('is-selected');
	dotsArray[selected]?.classList.add('is-selected');

	dotsArray[previous]?.setAttribute('aria-selected', false);
	dotsArray[selected]?.setAttribute('aria-selected', true);

	dotsArray[previous]?.setAttribute('tabindex', '-1');
	dotsArray[selected]?.setAttribute('tabindex', '0');

	embla.slideNodes?.()[previous]?.classList.remove('is-selected');
	embla.slideNodes?.()[selected]?.classList.add('is-selected');
};
